import cx from 'classnames'
import { FC } from 'react'

import { WizardDataStatusInterface } from 'src/types/WizardDataStatusInterface'
import { WIZARD_STATUS } from 'src/utils/constant'
import { getWizardStatusPlatformsFn } from 'src/utils/wizardUtils'
import WizardStatusIcon from './WizardStatusIcon'

import * as styles from './WizardStatusContent.scss'

interface WizardStatusContentItemHeaderProps {
  dashboard: WizardDataStatusInterface
}
const WizardStatusContentItemHeader: FC<WizardStatusContentItemHeaderProps> = ({ dashboard }) => {
  const { type, label, message } = dashboard

  let seatMessage = message

  if (type !== WIZARD_STATUS.success) {
    seatMessage = `${getWizardStatusPlatformsFn(dashboard).length} seats`
  }

  return (
    <div className={cx(styles.Header)}>
      <div className={styles.HeaderIcon}>
        <WizardStatusIcon status={type} />
      </div>
      <div className={styles.HeaderTitleContainer}>
        <h3>{label}</h3>
        <p>{seatMessage}</p>
      </div>
    </div>
  )
}

export default WizardStatusContentItemHeader
